import * as React from 'react';
import { TopModel } from '@goldwasserexchange/react-topmodel';
import { TextSnippetBase, } from './components';
export var textSnippetDefaultTopModelsObject = {
    TextSnippetBase: (React.createElement(TopModel, { name: "TextSnippetBase" }, TextSnippetBase)),
};
